/**
 * Bugherd @mention nodes rendered with HighlightedMentions-style React UI
 * (shared by MarkdownPreview and RichTextDescription).
 */

import { ReactNodeViewRenderer } from '@tiptap/react';
import { BugherdMention } from './bugherdMention';
import { BugherdMentionPreviewView } from '../components/BugherdMentionPreviewView';

export const BugherdMentionWithReactView = BugherdMention.extend({
  addNodeView() {
    return ReactNodeViewRenderer(BugherdMentionPreviewView);
  }
});
